<template>
    <el-container>
        <el-header>
            <div class="screen">
                <!-- <div class="screen_select">
                    周期:
                    <el-radio-group v-model="time_size" @change="ratio_change">
                        <el-radio-button label="周"></el-radio-button>
                        <el-radio-button label="月"></el-radio-button>
                    </el-radio-group>
                </div> -->
                <div class="screen_select">
                    日期：
                    <el-select v-model="stat_time" placeholder="请选择" @change="select_change">
                        <el-option
                            v-for="item in date_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="screen_select">
                    维度：
                    <el-select v-model="dimension" placeholder="请选择" @change="select_change">
                        <el-option
                            v-for="item in dimension_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </el-header>
        <el-main>
            <div style="height: 94%;padding:20px 0px;overflow: scroll;background:white;">
                <custom-table
                    ref="mytable"
                    table-id="fill_in_table"
                    :project-list-dl="tableData.projectList"
                    :show-coloums-dl="tableData.showColoums"
                    :column_mapper="tableData.column_mapper"
                    :sort-column-name-dl="tableData.sortColumnName"
                    :sort-column-order-dl="tableData.sortColumnOrder"
                    

                    :totalnums-dl="tableData.totalnums"
                    :pagesize-dl="tableData.pagesize"
                    :page-number-dl="tableData.pageNumber"

                    :fixed-columns="tableData.fixedList"
                    :fixed-right-columns="tableData.fixedRightList"

                    :disableDrag="true"
                    :sortable="false"
                    :sortableColumns="tableData.sortableColumns"

                    :pagination="tableData.pagination"

                    :is-loading-dl="tableData.detailLoading"
                    :use-virtual="false"
                    :row-hegit="0"

                    :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
                    :padding="'0px'"
                    :custom-column-width="tableData.customColumnWidth"

                    :exportBtn="true"
                    @exportBtnClick="exportBtnClick"
                />
            </div>
        </el-main>
    </el-container>
</template>

<script>
// 测试接口,后续根据实际换掉
import {getPassRateTimeOption, getPassRate, exportPassrateDetail} from '../../api/api';
import customTable from "@/component/CustomTable";
export default {
    name: "projectFillIn",
    components: {
        customTable
    },
    data() {
        return {
            time_size: "周",
            stat_time: "",
            dimension: "",
            date_options: [],
            dimension_options: [
                {"label": "业务部门", "value": "responsible_p_dept"},
                {"label": "业务组", "value": "responsible_s_dept"}
            ],
            tableData: {
                detailLoading: false,
                projectList: [],//表格列表所有数据
                column_mapper: {},//表头所有列的枚举
                showColoums: [],//当前显示的表头列
                sortColumnName: "",//需要排序的列名
                sortColumnOrder: "",//排序的命令
                totalnums: 10,//所有的数据条数
                pageNumber: 1,//当前页
                fixedList: [],
                pagesize: 20,//一页数据的行数（公用）
                pagination:true,
                customColumnWidth:{
                    dimension:200,
                    stat_time:200,
                    monthly_active_count:200,
                    pass_rate:200
                },
            }
        }
    },

    async mounted() {
        await this.ratio_change()
    },

    methods: {
        async ratio_change() {
            console.log(this.time_size)
            let res = await getPassRateTimeOption({
                time_size: this.time_size
            })
            this.date_options = res.respData.time_options
            this.stat_time = res.respData.time_options[0].value
            this.dimension = this.dimension_options[0].value
            await this.getData()
        },

        async select_change() {
            await this.getData()
        },

        async getData(){
            this.tableData.detailLoading = true
            let postData = {
                time_size: this.time_size,
                stat_time: this.stat_time,
                dimension: this.dimension
            }
            let res = await getPassRate(postData)
            const {respData: {cols_mapper, data, columns_list, totalnums}} = res
            this.tableData.column_mapper = cols_mapper
            this.tableData.projectList = data
            this.tableData.totalnums = totalnums
            this.tableData.showColoums = columns_list
            this.$nextTick(() => {
                this.tableData.detailLoading = false
            })
        },

        async exportBtnClick(param) {
            // console.log('***', data.name)
            let param2 = Object.assign({}, param)
            param2['value'] = param['dimension']
            param2['dimension'] = this.dimension
            console.log('detail', param2)
            let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
            try {
                let {data} = await exportPassrateDetail(param2)
                loadingInstance.close();
                const blob = new Blob([data])
                var date = new Date()
                let Y = date.getFullYear().toString()
                let M = (date.getMonth() + 1).toString().padStart(2, "0")
                let D = date.getDate().toString().padStart(2, "0")
                let H = date.getHours().toString().padStart(2, "0")
                let m = date.getMinutes().toString().padStart(2, "0")
                let s = date.getSeconds().toString().padStart(2, "0")
                let fileName = '合格率明细-' + Y + M + D + H + m + s + ".xlsx"

                const link = document.createElement('a')
                link.download = fileName
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.click()
                URL.revokeObjectURL(link.href)
                document.body.removeChild(link)
            } catch(err) {
                loadingInstance.close();
                var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                if (issafariBrowser) {
                this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
                } else {
                this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .screen {
        display: flex;
        margin-top: 20px;
    }
    .screen_select {
        margin-right: 100px;
    }
</style>
